export const bodyEl = document.querySelector("body");
export const overlayEl = document.querySelector(".overlay-bg");
